/**
 * Opens the "Ask ProCharted" panel (under the top search box) with a question
 * from anywhere in the app, e.g. Home's "Ask about your day" box. The top bar
 * (`main/Search/HeaderSearch.tsx`) listens; nothing happens when AI is off.
 */
export const ASK_EVENT = "proc:ask";

export type AskEventDetail = { question: string };

export const openAskPanel = (question: string): boolean => {
  const text = question.trim();
  if (!text) return false;
  window.dispatchEvent(
    new CustomEvent<AskEventDetail>(ASK_EVENT, { detail: { question: text } }),
  );
  return true;
};
